import React, { useState } from "react";
import { youtubeVideos } from "../../../Data/Data";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

const Filter = ({ setYoutubeData, setActiveVideo }) => {
  const [showDrop, setShowDrop] = useState(false);
  const [activeCat, setActiveCat] = useState("all");
  const categories = ["all", ...new Set(youtubeVideos.map((item) => item.category))];
  const newCat = categories.filter((item) => item !== activeCat);

  const handleSelect = (cat) => {
    setActiveCat(cat);
    const filter = youtubeVideos.filter((item) => item.category === cat);
    if (cat === "all") {
      setYoutubeData(youtubeVideos);
      setActiveVideo(youtubeVideos[0].link);
    } else {
      setYoutubeData(filter);
      setActiveVideo(filter[0].link);
    }
    setShowDrop(false);
  };

  return (
    <div className="w-[10rem] mt-3 relative ml-auto">
      <h2
        onClick={() => setShowDrop((prev) => !prev)}
        className="bg-box border p-[0.4rem] flex items-center justify-between
        cursor-pointer border-b border-gray-500 capitalize">
        {activeCat}
        <MdOutlineKeyboardArrowDown className="text-2xl" />
      </h2>
      {showDrop && (
        <div className="bg-white text-black absolute top-full left-0 right-0">
          {newCat.map((item, i) => (
            <p
              onClick={() => handleSelect(item)}
              key={i}
              className="hover:bg-gray-200 py-2 px-1 capitalize cursor-pointer">
              {item}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default Filter;
